const USD: string = require("./images/united-states-of-america.png");
const GBP: string = require("./images/england.png");
const CHF: string = require("./images/switzerland.png");
const AUD: string = require("./images/australia.png");
const JPY: string = require("./images/japan.png");
const MYR: string = require("./images/malaysia.png");
const SGD: string = require("./images/singapore.png");
const HKD: string = require("./images/hong-kong.png");
const CAD: string = require("./images/canada.png");
const DKK: string = require("./images/denmark.png");
const NOK: string = require("./images/norway.png");
const SEK: string = require("./images/sweden.png");
const TWD: string = require("./images/taiwan.png");
const KRW: string = require("./images/south-korea.png");
const CNY: string = require("./images/china.png");
const PHP: string = require("./images/philippines.png");
const SAR: string = require("./images/saudi-arabia.png");
const AED: string = require("./images/united-arab-emirates.png");
const QAR: string = require("./images/qatar.png");
const OMR: string = require("./images/oman.png");
const BHD: string = require("./images/bahrain.png");
const VND: string = require("./images/vietnam.png");
const BND: string = require("./images/brunei.png");
const KWD: string = require("./images/kuwait.png");
const ZAR: string = require("./images/south-africa.png");
const IDR: string = require("./images/indonesia.png");
const INR: string = require("./images/india.png");
const SCOT: string = require("./images/scotland.png");
const RUB: string = require("./images/russia.png");
const TRY: string = require("./images/turkey.png");
const MMK: string = require("./images/myanmar.png");
const LAK: string = require("./images/laos.png");
const THB: string = require("./images/thailand.png");
const NZD: string = require("./images/new-zealand.png");

export const flags:any = {
	"USD": USD,
	"GBP": GBP,
    "CHF": CHF,
    "AUD": AUD,
    "JPY": JPY,
    "MYR": MYR,
    "SGD": SGD,
    "HKD": HKD,
    "CAD": CAD,
    "DKK": DKK,
    "NOK": NOK,
    "SEK": SEK,
    "TWD": TWD,
    "KRW": KRW,
    "CNY": CNY,
    "PHP": PHP,
    "SAR": SAR,
    "AED": AED,
    "QAR": QAR,
    "OMR": OMR,
    "BHD": BHD,
    "VND": VND,
    "BND": BND,
    "KWD": KWD,
    "ZAR": ZAR,
    "IDR": IDR,
    "INR": INR,
    "SCOT": SCOT,
    "RUB": RUB,
    "TRY": TRY,
    "MMK": MMK,
    "LAK": LAK,
    "THB": THB,
    "NZD": NZD,
}